
<template>
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.875 4.75H4.45833H17.125"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5423 4.75016V15.8335C15.5423 16.2534 15.3755 16.6561 15.0786 16.9531C14.7816
      17.25 14.3789 17.4168 13.959 17.4168H6.04232C5.62239 17.4168 5.21966 17.25 4.92273
      16.9531C4.6258 16.6561 4.45898 16.2534 4.45898 15.8335V4.75016M6.83398
      4.75016V3.16683C6.83398 2.7469 7.0008 2.34418 7.29773 2.04724C7.59466 1.75031
      7.99739 1.5835 8.41732 1.5835H11.584C12.0039 1.5835 12.4066 1.75031 12.7036
      2.04724C13.0005 2.34418 13.1673 2.7469 13.1673 3.16683V4.75016"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.41602 8.7085V13.4585"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.584 8.7085V13.4585"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>